export default "__VITE_ASSET__CKgG$3Ud__"